export const RE_ENTRY_WARNING_LOAD_REQUESTED =
    'RE_ENTRY_WARNING_LOAD_REQUESTED';
export const RE_ENTRY_WARNING_LOAD_SUCCEEDED =
    'RE_ENTRY_WARNING_LOAD_SUCCEEDED';
export const RE_ENTRY_WARNING_LOAD_FAILED = 'RE_ENTRY_WARNING_LOAD_FAILED';
export const RE_ENTRY_WARNING_LOAD_CANCELED = 'RE_ENTRY_WARNING_LOAD_CANCELED';
export const RE_ENTRY_WARNING_SET = 'RE_ENTRY_WARNING_SET';
export const RE_ENTRY_WARNING_RESET = 'RE_ENTRY_WARNING_RESET';

export const RE_ENTRY_WARNING_LOAD_NAMESPACE = 'RE_ENTRY_WARNING_LOAD';
